import {
  GridColDef,
  isAutogeneratedRow,
} from "@mui/x-data-grid-premium";
import { IconButton, Stack } from "@mui/material";
import { Download, Delete } from "@mui/icons-material";
import { AdditionalDocumentDTO } from "../../types/AdditionalDocumentDTO";
import { withCaseInsensitiveStringFilters } from "../../utils/stringFilterOperators";

type Params = {
  onDownload: (doc: AdditionalDocumentDTO) => void;
  onDelete: (doc: AdditionalDocumentDTO) => void;
};

export function createAdditionalDocumentsColumns(
  t: (key: string, options?: any, ns?: any) => string,
  { onDownload, onDelete }: Params
): GridColDef<AdditionalDocumentDTO>[] {
  return [
    {
      field: "systemCreatedAt",
      headerName: t("systemCreatedAt"),
      width: 160,
      type: "date",
      sortable: true,
      filterable: true,
      aggregable: false,

      valueGetter: (value, row) => {
        if (isAutogeneratedRow(row)) {
          return null;
        }

        if (!value) {
          return null;
        }

        return new Date(value);
      },

      valueFormatter: (value) =>
        value ? new Date(value as string).toLocaleDateString() : "",
    },

    withCaseInsensitiveStringFilters({
      field: "fileName",
      headerName: t("fileName"),
      flex: 1,
      minWidth: 200,
      sortable: true,
      filterable: true,
      aggregable: false,
    }) as GridColDef<AdditionalDocumentDTO>,

    withCaseInsensitiveStringFilters({
      field: "Description",
      headerName: t("description"),
      flex: 1,
      minWidth: 200,
      sortable: true,
      filterable: true,
      aggregable: false,
    }) as GridColDef<AdditionalDocumentDTO>,

    withCaseInsensitiveStringFilters({
      field: "categoryCode",
      headerName: t("categoryCode"),
      width: 140,
      sortable: true,
      filterable: true,
      aggregable: false,
    }) as GridColDef<AdditionalDocumentDTO>,

    {
      field: "accountingCategory",
      headerName: t("accountingCategory"),
      width: 150,
      type: "boolean",
      sortable: true,
      filterable: true,
      aggregable: false,

      valueGetter: (_value, row) =>
        isAutogeneratedRow(row) ? null : Boolean(row.accountingCategory),
    },

    {
      field: "actions",
      headerName: t("actions"),
      width: 120,
      sortable: false,
      filterable: false,
      aggregable: false,
      disableColumnMenu: true,
      align: "center",
      headerAlign: "center",
      cellClassName: "actions-cell",

      renderCell: (params) => {
        if (isAutogeneratedRow(params.row)) {
          return null;
        }

        return (
          <Stack direction="row" spacing={0.5}>
            <IconButton
              size="small"
              aria-label={t("download")}
              onClick={(e) => {
                e.stopPropagation();
                onDownload(params.row);
              }}
            >
              <Download fontSize="small" />
            </IconButton>

            <IconButton
              size="small"
              color="error"
              aria-label={t("delete")}
              onClick={(e) => {
                e.stopPropagation();
                onDelete(params.row);
              }}
            >
              <Delete fontSize="small" />
            </IconButton>
          </Stack>
        );
      },
    },
  ];
}